import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import { getPostImage } from '@utils/post.helper';
import PostType, { CampaignType } from 'constants/postType.constants';
import { cx } from 'cva';
import Image from 'next/image';
import React from 'react';
import PostVideos from './PostVideos';
import { isArray, size } from 'lodash-es';
import VideoPlayer from '../VideoPlayer';

const getPostIndicatorIcon = (post) => {
  let url;
  switch (post.sourcePostType) {
    case PostType.Campaign:
      if (post.sourcePostData.campaignType === CampaignType.Fundraiser) {
        return '/assets/icons/fundraise-campaign.svg';
      }
      return '/assets/icons/inkind-campaign.svg';
    case PostType.Volunteering:
      return '/assets/icons/volunteer.svg';
    default:
      return null;
  }
};

function PostVideo(props) {
  const { post, className, type } = props;

  if ((post.sourcePostType !== PostType.NewsFeeds) || (post.renderProps.videoUrls.length > 0) || type === 'celebrate') {
    const indicatorIcon = getPostIndicatorIcon(post);
    const hasMultipleVideos =
      isArray(post.renderProps.videoUrls) &&
      size(post.renderProps.videoUrls) > 1;
    let video = isArray(post.renderProps.videoUrls) && size(post.renderProps.videoUrls) > 0 ? { url: post.renderProps.videoUrls[0] } : type === 'celebrate' ? { url: post.renderProps.imageUrls } : null;

    if(!video) {
      return null;
    }

    return (
      <div
        className={cx(
          'relative w-full aspect-video flex justify-center items-center',
          className
        )}>
        {hasMultipleVideos ? (
          <PostVideos videoUrls={post.renderProps.videoUrls || []} />
        ) : (
          <VideoPlayer
            src={video.url}
            className="object-contain"
            sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
          />
        )}
        {indicatorIcon && (
          <div className="absolute top-2 right-2 w-12 h-12 lg:w-[72px] lg:h-[72px] rounded-full bg-white flex items-center justify-center p-3 border border-gray-100">
            <img src={indicatorIcon} alt="Post Indicator Icon" />
          </div>
        )}
      </div>
    );
  }
  return null;
}

export default PostVideo;
